// Polyfills
import 'Utils/_closest.polyfill.js';
import 'Utils/_matches.polyfill.js';

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Components
import Swiper, { Pagination, Navigation, Autoplay, EffectFade } from 'swiper';


document.addEventListener('DOMContentLoaded', function() {
	//let mm = gsap.matchMedia();
	var r = document.querySelector(':root');
	var body = document.body;
	
	/*
	// HELP CHECK
	let viewportWidthEl = document.getElementById('viewport-width');

	function viewportCalc() {
		//let viewportHeight = window.innerHeight;
		let viewportWidth = window.innerWidth;
		//console.log(viewportWidth);
		//console.log(viewportHeight);

		if(window.innerWidth < 576){
			viewportWidthEl.style.backgroundColor = "red";
            viewportWidthEl.innerText = 'xs';
			//viewportHeightEl.style.backgroundColor = "red";

		} else if(window.innerWidth < 768) {
			viewportWidthEl.style.backgroundColor = "orange";
            viewportWidthEl.innerText = 'sm';

			//viewportHeightEl.style.backgroundColor = "purple";

		} else if(window.innerWidth < 992) {
			viewportWidthEl.style.backgroundColor = "green";
            viewportWidthEl.innerText = 'md';
			//viewportHeightEl.style.backgroundColor = "blue";

		} else if(window.innerWidth < 1200) {
			viewportWidthEl.style.backgroundColor = "blue";
            viewportWidthEl.innerText = 'lg';
			//viewportHeightEl.style.backgroundColor = "green";

		} else if(window.innerWidth < 1400) {
			viewportWidthEl.style.backgroundColor = "purple";
            viewportWidthEl.innerText = 'xl';
			//viewportHeightEl.style.backgroundColor = "orange";
		}

		else {
			viewportWidthEl.style.backgroundColor = "black";
            viewportWidthEl.innerText = 'xxl';
			//viewportHeightEl.style.backgroundColor = "black";
		}
	}

	viewportCalc();

	// RESIZE
	window.addEventListener("resize", function(){
		viewportCalc();
	});
	*/


	// PARALLAX
	/*
	const imgP = document.querySelector(".section.--formations-online img");

	if (imgP) {
		let targetY = 0;
		let currentY = 0;
		
		function animate() {
			if (window.innerWidth >= 768) {
				currentY += (targetY - currentY) * 0.1; // inertie
				imgP.style.transform = `translateY(${currentY}px) scale(1.2)`;
				requestAnimationFrame(animate);
			} 
		}
		
		window.addEventListener("scroll", () => {
			let speed;
		
			if (window.innerWidth >= 1400) {
				speed = 0.175;
			} else if (window.innerWidth >= 992) {
				speed = 0.125;
			} else {
				speed = 0.05;
			}
		
			targetY = -window.scrollY * speed;
		});
		
		animate();

		// RESIZE
		window.addEventListener("resize", function(){
			animate();
		});
	}
	*/

	// SWIPERS
	const swiperStructuresNeuves = new Swiper('.--temoignages .swiper-container', {
		modules: [Navigation, Autoplay, Pagination, EffectFade],
		loop: true,
		grabCursor: true,
		spaceBetween: 0,
		effect: "fade",
		autoplay: {
			delay: 5000,
		},
		fadeEffect: {
			crossFade: true
		},
		//autoHeight: true,
		slidesPerView: 1,
		navigation: {
			nextEl: ".--temoignages .swiper-button-next",
			prevEl: ".--temoignages .swiper-button-prev",
		}, 
		pagination: {
			el: ".--temoignages .swiper-pagination",
			clickable: true,   // ← Active le clic !
		},
		breakpoints: {
			// when window width is >= 320px
			768: {
			slidesPerView: 1,
			spaceBetween: 20
			},
			// when window width is >= 768px
			992: {
				spaceBetween: 40,
				slidesPerView: 1,
			},
			// when window width is >= 992px
			1200: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			// when window width is >= 2000px
			2000: {
				slidesPerView: 1,
				spaceBetween: 40,
			}
		},
	});


	// APPEAR ANIMATION
	const sections = document.querySelectorAll('.section');

	const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		if(entry.isIntersecting){
		const section = entry.target;
		section.classList.add('visible');

		// Animation avec délai pour chaque élément du text-container
		const textElements = section.querySelectorAll('.text-container *:not(.swiper-pagination-bullet):not(.swiper-wrapper):not(.btn):not(.swiper-slide):not(.swiper-pagination):not(.swiper-container)');
		textElements.forEach((el, index) => {
			el.style.transitionDelay = `${(index + 1) * 0.15}s`;
		});

		observer.unobserve(section); // on anime une seule fois
		}
	});
	}, {
	threshold: 0.2 // déclenche quand 20% de la section est visible
	});

	sections.forEach(section => observer.observe(section));




	// HEADER TINY ON SCROLL
	/*
	mm.add("(min-width: 992px)", () => {
		ScrollTrigger.create({
			start: "top -100px",
			//scroller: scrollerBox,
			end: 99999,
			//markers: true,

			toggleClass: { targets: 'header', className: '--tiny' },
		});
	});

	mm.add("(max-width: 991px)", () => {
		ScrollTrigger.create({
			start: "top -30px",
			//scroller: scrollerBox,
			end: 99999,
			//markers: true,

			toggleClass: { targets: 'header', className: '--tiny' },
		});
	});
	*/	
})


